// internal/OperationsPage.jsx — Hub Opérations : intègre les OPS existants (une source de vérité, plusieurs accès).
import InternalLayout, { S, IT } from "@/internal/InternalLayout";
import { useNavigate } from "react-router-dom";

const MODULES = [
  { t: "Validation AYA Pro", s: "Inscriptions professionnelles — refondu AYA Internal", to: "/internal/operations/pro-validation", icon: "🏪", neuf: true },
  { t: "Transport Pro", s: "Réception des demandes : courses taxi, billets car, vols, missions VTC", to: "/transport-pro", icon: "🚖", neuf: true },
  { t: "OPS principal", s: "Dashboard opérationnel historique", to: "/ops", icon: "📊" },
  { t: "OPS B2B (CRUD)", s: "Répertoires & fiches", to: "/ops-b2b", icon: "🗂" },
  { t: "Salle Ops Live", s: "Supervision live commerce", to: "/ops/live", icon: "🛰" },
  { t: "Commandes", s: "Suivi des commandes", to: "/ops/commandes", icon: "📦" },
  { t: "Top fiches LLM", s: "Impressions des fiches", to: "/ops/impressions", icon: "📈" },
  { t: "Digests mensuels", s: "Rapports B2B", to: "/ops/digests-mensuels", icon: "📨" },
  { t: "Console Partenaires", s: "Imports partenaires", to: "/ops-partners", icon: "🤝" },
  { t: "Gouvernance", s: "Dashboard gouvernance", to: "/governance", icon: "⚖️" },
  { t: "Carte de couverture", s: "Couverture géographique", to: "/carte-publique", icon: "🗺" },
];

export default function OperationsPage() {
  const navigate = useNavigate();
  return (
    <InternalLayout title="Opérations" subtitle="Toutes les fonctions opérationnelles d'AYA — existantes et refondues — en un seul endroit.">
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(230px, 1fr))", gap: 10 }} data-testid="ops-hub">
        {MODULES.map((m) => (
          <button key={m.t} data-testid={`ops-mod-${m.t.toLowerCase().replace(/[^a-z]+/g, "-")}`} onClick={() => navigate(m.to)}
            style={{ ...S.card, padding: "14px 15px", textAlign: "left", cursor: "pointer", color: IT.text, fontFamily: "inherit", position: "relative" }}>
            {m.neuf && <span style={{ position: "absolute", top: 10, right: 10, fontSize: 8.5, fontWeight: 900, color: "#04120B", background: IT.green, borderRadius: 999, padding: "2px 7px" }}>REFONDU</span>}
            <div style={{ fontSize: 20 }}>{m.icon}</div>
            <div style={{ fontSize: 13.5, fontWeight: 800, marginTop: 6 }}>{m.t}</div>
            <div style={{ fontSize: 11, color: IT.muted, marginTop: 3 }}>{m.s}</div>
          </button>
        ))}
      </div>
    </InternalLayout>
  );
}
